<template>
  <div>
    <div :class="['info-title', disabled ? 'title-disabled' : '']">
      祈福人{{ prayerIndex + 1 }}
    </div>

    <checkbox
      :id="'lightTypes' + prayerIndex"
      title="選擇燈別"
      :options="lightInfo"
      v-model="info.lightTypes"
      :disabled="disabled"
      :errorText="errorText.lightTypes"
    />

    <div class="grid-container">
      <inputField
        :id="'name' + prayerIndex"
        label="姓名"
        placeholder="請輸入"
        :inputType="isRecord ? 'text' : 'name'"
        maxLength="50"
        class="banquet-name"
        :value="info.name"
        @onInput="onInputName($event)"
        :disabled="disabled"
        :errorText="errorText.name"
      />

      <dropdownBtn
        :id="'sex' + prayerIndex"
        v-model="info.sex"
        placeholder="請選擇"
        label="性別"
        :options="options_gender"
        :disabled="disabled"
        :errorText="errorText.sex"
      />

      <datePicker
        :id="'birthDate' + prayerIndex"
        label="出生日期（國曆）"
        v-model="info.birthDate"
        :disabled="disabled"
        :errorText="errorText.birthDate"
        :isRecord="isRecord"
      />
      <inputField
        :id="'birthHour' + prayerIndex"
        label="出生時辰"
        class="birth-time"
        :disabled="true"
        :value="info.birthHour"
        v-if="isRecord"
      />
      <dropdownBtn
        :id="'birthHour' + prayerIndex"
        v-model="info.birthHour"
        placeholder="請選擇"
        label="出生時辰"
        class="birth-time"
        :options="chineseTimeList"
        :disabled="disabled"
        :errorText="errorText.birthHour"
        v-else
      />
    </div>
    <div class="contact-block">
      <div class="addrs-title-block">
        <div :class="['addrs-title', disabled ? 'addrs-title-disabled' : '']">
          聯絡電話
        </div>
        <checkbox
          :id="'contactCheckPhone' + prayerIndex"
          :options="options_phone"
          v-model="select_phone"
          v-if="prayerIndex > 0 && !disabled"
          :disabled="disabled"
        />
      </div>
    </div>
    <inputField
      class="contact-phone"
      :id="'phone' + prayerIndex"
      label="手機號碼/聯絡電話"
      placeholder="請輸入"
      :inputType="isRecord ? 'text' : 'phone'"
      maxLength="11"
      :value="info.phone"
      @onInput="onInputPhone($event)"
      :disabled="select_phone.length > 0 || disabled"
      :errorText="errorText.phone"
    />
    <div class="addrs-title-block">
      <div :class="['addrs-title', disabled ? 'addrs-title-disabled' : '']">
        居住地址
      </div>
      <checkbox
        :id="'houseCheckAddr' + prayerIndex"
        :options="options_addrs"
        v-model="select_addrs"
        v-if="prayerIndex > 0 && !disabled"
        :disabled="disabled"
      />
    </div>

    <addrsField
      :id="'address' + prayerIndex"
      v-model="info.address"
      :disabled="select_addrs.length > 0 || disabled"
      @input="onInputAddrHouse()"
      :errorText="errorText.address"
      :isRecord="isRecord"
    />


    <div class="line" v-if="prayerIndex + 1 < totalCount" />
  </div>
</template>

<script scoped>
import Vue from 'vue';
import checkbox from 'Components/checkbox/checkboxGroup.vue';
import dropdownBtn from 'Components/dropdown/dropdown.vue';
import inputField from 'Components/inputField/inputField.vue';
import datePicker from 'Components/date/datePicker.vue';
import addrsField from 'Components/addr/addrsField.vue';
import ChineseTimeList from 'Assets/mockData/ChineseTimeList.json';
// import radioButton from 'Components/button/radioButton.vue';
import validation from 'Core/validation.js';
import store from 'Store/store';

export default {
  name: 'ServiceLightPersonInfo',
  components: {
    checkbox,
    dropdownBtn,
    inputField,
    datePicker,
    addrsField,
    // radioButton,
  },
  data() {
    return {
      fare: store.state.main.onlineStatus.lightInfo.givewayFare,
      info: {},
      chineseTimeList: ChineseTimeList.details,
      options_phone: [{ text: '同祈福人1', value: 'Y' }],
      options_addrs: [{ text: '同祈福人1', value: 'Y' }],
      options_addrs_fare: [{ text: '同祈福人1', value: 'Y' }],
      options_addrs_fare_first: [{ text: '同居住地址', value: 'Y' }],
      options_fare: [
        { text: '不需要', value: 0 },
        { text: '現場領取', value: 1 },
        { text: '郵寄', value: 2 },
      ],
      select_addrs: [],
      select_addrs_fare: [],
      select_phone: [],
      options_gender: [
        { text: '男', value: 'M' },
        { text: '女', value: 'F' },
      ],

      errorText: {
        lightTypes: '',
        name: '',
        sex: '',
        birthDate: '',
        birthHour: '',
        phone: '',
        address: {
          county: '',
          town: '',
          detail: '',
        },
        givewayAddress: {
          county: '',
          town: '',
          detail: '',
        },
        givewayName: '',
        givewayType: '',
      },
    };
  },
  watch: {
    'info.lightTypes': function() {
      this.$emit('lightsChange');
    },
    select_addrs_fare: function() {
      this.copyFirstAddrsToFare();
    },
    select_addrs: function() {
      this.copyFirstAddrs();
    },
    select_phone: function() {
      this.copyFirstPhone();
    },
    'firstAddrs.county': function() {
      this.copyFirstAddrs();
      this.copyFirstAddrsToFare();
    },
    'firstAddrs.town': function() {
      this.copyFirstAddrs();
      this.copyFirstAddrsToFare();
    },
    'firstAddrs.detail': function() {
      this.copyFirstAddrs();
      this.copyFirstAddrsToFare();
    },
    firstPhone: function() {
      this.copyFirstPhone();
    },
  },
  beforeMount() {
    this.info = this.prayerInfo;

    if (this.isRecord) {
      this.info.name = Vue.filter('securityHidden')(this.info.name, 'O', 1, 1);
      this.info.phone = Vue.filter('securityHidden')(
        this.info.phone,
        '*',
        3,
        0
      );
      this.info.birthHour = Vue.filter('securityHidden')(
        this.info.birthHour,
        '*',
        0,
        0
      );
      this.info.address.town = Vue.filter('securityHidden')(
        this.info.address.town,
        'O',
        1,
        0
      );
      this.info.address.detail = Vue.filter('securityHidden')(
        this.info.address.detail,
        'O',
        0,
        0
      );
    }
  },
  props: {
    id: {
      type: String,
    },
    prayerIndex: {
      type: Number,
      default: 0,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    lightInfo: {},
    givewayInfo: {},
    prayerInfo: {},
    firstAddrs: {},
    value: {},
    firstPhone: {
      type: String,
    },
    isRecord: {
      type: Boolean,
    },
  },
  methods: {
    changeFareType() {
      if (this.info.givewayType !== 2) {
        this.select_addrs_fare = [];
        this.info.givewayAddress.county = '';
        this.info.givewayAddress.town = '';
        this.info.givewayAddress.detail = '';
      }

      if (this.info.givewayType === 0) {
        this.info.givewayName = '';
      }
    },
    copyFirstAddrs() {
      if (this.prayerIndex === 0) {
        return;
      }

      if (
        this.select_addrs != null &&
        this.select_addrs != undefined &&
        this.select_addrs.length > 0
      ) {
        if (this.firstAddrs != null && this.firstAddrs != undefined) {
          Object.assign(this.info.address, this.firstAddrs);
        }
      }
    },
    copyFirstAddrsToFare() {
      if (this.prayerIndex === 0) {
        if (
          this.select_addrs_fare != null &&
          this.select_addrs_fare != undefined &&
          this.select_addrs_fare.length > 0
        ) {
          if (this.info.address != null && this.info.address != undefined) {
            Object.assign(this.info.givewayAddress, this.info.address);
          }
        }

        return;
      }

      if (
        this.select_addrs_fare != null &&
        this.select_addrs_fare != undefined &&
        this.select_addrs_fare.length > 0
      ) {
        if (this.firstAddrs != null && this.firstAddrs != undefined) {
          Object.assign(this.info.givewayAddress, this.firstAddrs);
        }
      }
    },
    copyFirstPhone() {
      if (this.prayerIndex === 0) {
        return;
      }

      if (
        this.select_phone != null &&
        this.select_phone != undefined &&
        this.select_phone.length > 0
      ) {
        if (this.firstPhone != null && this.firstPhone != undefined) {
          this.info.phone = this.firstPhone;
        }
      }
    },
    onInputName(inputValue) {
      this.info.name = inputValue['name' + this.prayerIndex];
    },
    onInputPhone(inputValue) {
      this.info.phone = inputValue['phone' + this.prayerIndex];
    },
    onInputAddrHouse() {
      if (this.select_addrs_fare.length > 0 && this.prayerIndex === 0) {
        Object.assign(this.info.givewayAddress, this.info.address);
        this.onInputAddrGiveway();
      }
    },
    onInputAddrGiveway() {},
    changeLightError(errorTypes) {
      if (
        this.info.lightTypes.some((element) => errorTypes.includes(element))
      ) {
        const lightNameObj = {};
        store.state.main.onlineStatus.lightInfo.lightList.forEach((light) => {
          lightNameObj[light.type] = light.name;
        });
        this.errorText.lightTypes =
          errorTypes.map((element) => lightNameObj[element]).join('、') +
          '剩餘數量不足';
      }
    },
    checkError() {
      // 清空錯誤
      Object.keys(this.errorText)
        .filter(
          (element) => element !== 'address' && element !== 'givewayAddress'
        )
        .forEach((element) => (this.errorText[element] = ''));

      Object.keys(this.errorText)
        .filter(
          (element) => element === 'address' || element === 'givewayAddress'
        )
        .forEach((element) =>
          Object.keys(this.errorText[element]).forEach(
            (errorAddress) => (this.errorText[element][errorAddress] = '')
          )
        );
      // 檢核欄位
      Object.keys(this.info)
        .filter(
          (element) =>
            // false === (element === 'givewayName' && this.info.givewayType === 0)
            false === (element === 'givewayName' || element === 'givewayType')
        )
        .forEach((element) => {
          if (this.info[element] === '') {
            this.errorText[element] = '必填';
          }
        });

      if (this.info.lightTypes.length === 0) {
        this.errorText.lightTypes = '必填';
      }

      Object.keys(this.info.address).forEach((element) => {
        if (this.info.address[element] === '') {
          this.errorText.address[element] = '必填';
        }
      });

      if (this.info.givewayType === 2) {
        Object.keys(this.info.givewayAddress).forEach((element) => {
          if (this.info.givewayAddress[element] === '') {
            this.errorText.givewayAddress[element] = '必填';
          }
        });
      }

      const phoneValidateResult = validation.phone.regex.test(this.info.phone);
      if (false === phoneValidateResult) {
        this.errorText.phone = validation.phone.msg;
      }

      const addressValidateResult = this.info.address.detail.includes('號');
      if (false === addressValidateResult) {
        this.errorText.address.detail = '格式錯誤';
      }
      const givewayAddressValidateResult =
        this.info.givewayType !== 2 ||
        this.info.givewayAddress.detail.includes('號');
      if (false === givewayAddressValidateResult) {
        this.errorText.givewayAddress.detail = '格式錯誤';
      }

      const checkResult =
        Object.values(this.errorText).every(
          (element) =>
            element !== '必填' &&
            Object.values(element).every((subElement) => subElement !== '必填')
        ) &&
        phoneValidateResult &&
        addressValidateResult &&
        givewayAddressValidateResult;

      return { result: checkResult, errorText: this.errorText };
    },
  },
  computed: {},
};
</script>

<style>
.info-title {
  color: black;
  font-weight: bold;
  font-size: 16px;
  margin-top: 50px;
  margin-bottom: 30px;
}
.title-disabled {
  color: #b18147;
}

.contact-block,
.contact-phone {
  width: 50%;
}

.addrs-title-block {
  height: 30px;
  display: flex;
  justify-content: space-between;
}

.addrs-title {
  color: #b18147;
  font-weight: bold;
  font-size: 12px;
  margin-top: 5px;
}

.addrs-title-block > div > div > div > .custom-control-inline {
  margin-right: 0;
}

.addrs-title-disabled {
  color: gray;
}
.line {
  margin-top: 30px;
  width: 100%;
  border-top: 1px solid;
  border-color: black;
}
.givewayTip {
  color: black;
  font-size: 16px;
}

@media (min-width: 768px) {
  .grid-container {
    display: grid;
    grid-template-columns: 50% 49%;
    grid-column-gap: 10px;
  }
  .birth-time {
    margin-top: 20px;
  }
}
</style>
